import api from '../api';
import secureStorage from '../../utils/SecureStorage';

const EstabelecimentoService = {
  removeMask: (value, length = null) => {
    if (!value) return '';
    // Converte para string se não for
    const stringValue = String(value);
    let newValue = stringValue.replace(/\D/g, '');
    return length ? newValue.slice(-length) : newValue;
  },

  applyCpfCnpjMask: (value) => {
    if (!value) return '';
    const stringValue = String(value).replace(/\D/g, '');
    if (stringValue.length <= 11) {
      // CPF
      return stringValue.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      // CNPJ
      return stringValue.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
  },

  toUpperCase: (value) => {
    if (!value) return '';
    return String(value).toUpperCase();
  },

  validateFields: (estabelecimento) => {
    const { nome_fantasia, id_rede, contato, endereco } = estabelecimento;
    if (!nome_fantasia) {
      alert("Você precisa informar o Nome do Estabelecimento");
      return false;
    } else if (!id_rede || id_rede.length < 10) {
      alert("Ocorreu um problema. Por favor, entre em contato com o suporte.");
      return false;
    } else if (!endereco.rua || !endereco.numero || !endereco.bairro || !endereco.cep || !endereco.cidade || !endereco.estado) {
      alert("Você precisa informar o endereço completo");
      return false;
    }
    return true;
  },

  saveEstabelecimento: async (estabelecimento, isImport = false) => {
    try {
      if (!EstabelecimentoService.validateFields(estabelecimento)) {
        throw new Error("Campos obrigatórios não preenchidos");
      }

      // Limpa as máscaras dos campos e converte tipos
      const estabelecimentoToSave = { ...estabelecimento };
      
      // Remove _id e id apenas se for importação
      if (isImport) {
        delete estabelecimentoToSave._id;
        delete estabelecimentoToSave.id;
      }
      
      // Converte textos para caixa alta
      estabelecimentoToSave.nome_fantasia = EstabelecimentoService.toUpperCase(estabelecimentoToSave.nome_fantasia);
      estabelecimentoToSave.Razao_Social = EstabelecimentoService.toUpperCase(estabelecimentoToSave.Razao_Social);
      
      // Trata campos que podem ser undefined ou null
      if (estabelecimentoToSave.cpf_cnpj) {
        estabelecimentoToSave.cpf_cnpj = EstabelecimentoService.removeMask(estabelecimentoToSave.cpf_cnpj);
      }
      
      // Converte campos numéricos para string e endereço para caixa alta
      if (estabelecimentoToSave.endereco) {
        estabelecimentoToSave.endereco.rua = EstabelecimentoService.toUpperCase(estabelecimentoToSave.endereco.rua);
        estabelecimentoToSave.endereco.bairro = EstabelecimentoService.toUpperCase(estabelecimentoToSave.endereco.bairro);
        estabelecimentoToSave.endereco.cidade = EstabelecimentoService.toUpperCase(estabelecimentoToSave.endereco.cidade);
        estabelecimentoToSave.endereco.estado = EstabelecimentoService.toUpperCase(estabelecimentoToSave.endereco.estado);
        estabelecimentoToSave.endereco.complemento = EstabelecimentoService.toUpperCase(estabelecimentoToSave.endereco.complemento);
        
        if (estabelecimentoToSave.endereco.numero) {
          estabelecimentoToSave.endereco.numero = String(estabelecimentoToSave.endereco.numero);
        }
        if (estabelecimentoToSave.endereco.cep) {
          estabelecimentoToSave.endereco.cep = EstabelecimentoService.removeMask(estabelecimentoToSave.endereco.cep);
        }
        if (estabelecimentoToSave.endereco.latitude) {
          estabelecimentoToSave.endereco.latitude = String(estabelecimentoToSave.endereco.latitude);
        }
        if (estabelecimentoToSave.endereco.longitude) {
          estabelecimentoToSave.endereco.longitude = String(estabelecimentoToSave.endereco.longitude);
        }
      }
      
      // Garante que o id_rede está presente
      const id_rede = secureStorage.getItem("id_r");
      if (!id_rede) {
        throw new Error("ID da rede não encontrado. Por favor, faça login novamente.");
      }

      // Formata as datas corretamente
      const now = new Date();
      estabelecimentoToSave.data_criacao = now.toISOString();
      estabelecimentoToSave.data_update = now.toISOString();

      const _id = estabelecimentoToSave._id?.$oid;
      const apiUr = process.env.REACT_APP_API_BASE_3;

      if (!apiUr) {
        throw new Error("Configuração da API não encontrada");
      }

      let response;
      if (_id && !isImport) {
        // Se tiver _id e não for importação, atualiza
        estabelecimentoToSave.id = _id;
        response = await api.put(`${apiUr}${_id}?id_rede=${id_rede}`, estabelecimentoToSave);
      } else {
        // Se não tiver _id ou for importação, cria novo
        // Remove campos que podem causar problemas
        delete estabelecimentoToSave._id;
        delete estabelecimentoToSave.id;
        
        // Garante que o id_rede está no objeto
        estabelecimentoToSave.id_rede = id_rede;
        
        // Adiciona verificado como false para novos registros
        estabelecimentoToSave.verificado = false;
        
        // Garante que os campos de data estão no formato correto
        estabelecimentoToSave.data_criacao = now.toISOString();
        estabelecimentoToSave.data_update = now.toISOString();
        
        // Garante que os campos booleanos estão corretos
        estabelecimentoToSave.blocked = Boolean(estabelecimentoToSave.blocked);
        estabelecimentoToSave.inactive = Boolean(estabelecimentoToSave.inactive);
        
        // Garante que o contato está no formato correto
        if (!estabelecimentoToSave.contato) {
          estabelecimentoToSave.contato = {
            celular: '',
            WhatsApp: '',
            observacoes: ''
          };
        }
        
        // Garante que o endereço está no formato correto
        if (!estabelecimentoToSave.endereco) {
          estabelecimentoToSave.endereco = {
            rua: '',
            numero: '',
            complemento: '',
            bairro: '',
            cep: '',
            cidade: '',
            estado: '',
            latitude: '',
            longitude: '',
            poligonoEstabelecimento: []
          };
        }
        
        // Garante que o poligonoEstabelecimento está no formato correto
        if (!estabelecimentoToSave.endereco.poligonoEstabelecimento) {
          estabelecimentoToSave.endereco.poligonoEstabelecimento = [];
        }
        
        // Garante que o email está no formato correto
        if (estabelecimentoToSave.contato.email) {
          estabelecimentoToSave.contato.email = estabelecimentoToSave.contato.email.toUpperCase();
        }
        
        response = await api.post(`${apiUr}?id_rede=${id_rede}`, estabelecimentoToSave);
      }

      if (response.data) {
        return response.data;
      } else {
        throw new Error("Resposta inválida do servidor");
      }
    } catch (error) {
      console.error("Erro ao salvar estabelecimento:", error);
      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      } else if (error.message) {
        throw new Error(error.message);
      } else {
        throw new Error("Erro ao salvar o estabelecimento. Por favor, tente novamente.");
      }
    }
  }
};

export default EstabelecimentoService;
